import React from "react";
import { Dialog, Heading, Modal } from "react-aria-components";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Themed } from "../../styles/themes";
import type { Theme } from "../../styles/themes";
import { Clickable } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./SlideoverModal.module.scss";

export type SlideoverModalProps = {
    isOpen: boolean;
    onClose: () => void;
    theme: Theme;
    title: string;
    titleClassName?: string;
    panelClassName?: string;
    children: React.ReactNode;
};

export const SlideoverModal = ({
    isOpen,
    onClose,
    theme,
    title,
    titleClassName,
    panelClassName,
    children,
}: SlideoverModalProps) => (
    <Modal
        className={styles.modal}
        isOpen={isOpen}
        onOpenChange={(open) => {
            if (!open) onClose();
        }}
        isDismissable
    >
        <Dialog className={styles.dialog}>
            <Clickable
                className={styles.overlay}
                onPress={onClose}
                aria-hidden="true"
                tabIndex={-1}
            />
            <Themed
                theme={theme}
                tag="section"
                className={concatClassNames([styles.panel, panelClassName])}
            >
                <header className={styles.header}>
                    <Heading
                        slot="title"
                        className={concatClassNames([
                            styles.title,
                            titleClassName,
                        ])}
                    >
                        {title}
                    </Heading>
                    <Clickable className={styles.close} onPress={onClose}>
                        <Svg name="x" visuallyHiddenText={t`Close`} />
                    </Clickable>
                </header>
                {children}
            </Themed>
        </Dialog>
    </Modal>
);
